import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Box } from "@material-ui/core";
import { MinimalTopBar } from "components/MinimalTopBar";
import AnimationRouteTransition1 from "components/AnimationRouteTransition1";

export default function AnimationRouteTransition1View() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="sm">
      <MinimalTopBar onGoBack={handleGoBack} />
      <Box mt={3}>
        <AnimationRouteTransition1 />
      </Box>
    </Container>
  );
}